<div class="root" [class.open]="openDemoInstruction">
  <div class="arrow_div">
    <div
      class="cursor arrow"
      [class.right]="openDemoInstruction"
      (click)="transition()"
      [title]="openDemoInstruction ? '' : 'Instruction Guide'"
    >
      {{ modalOpen ? ">" : "?" }}
    </div>
  </div>

  @if (true) {
  <div class="accordion_div" [class.open]="openDemoInstruction">
    <div class="title">Choose Your Experience</div>
    <div class="des mb-1">How would you like to explore Shohay?</div>
    <div id="accordion" class="accordion">
      <div class="card" id="h1">
        <div
          class="btn btn-link c_b"
          data-bs-toggle="collapse"
          data-bs-target="#c1"
          aria-expanded="true"
          aria-controls="c1"
        >
          Continue as a Donor
        </div>
        <div
          id="c1"
          class="collapse"
          aria-labelledby="h1"
          data-bs-parent="#accordion"
        >
          <div class="card-body">
            <div class="sub_title">Find and Support NGOs</div>
            <div class="btn c_b">NGO Directory</div>
            <div class="btn c_b">Browse Campaigns</div>
            <div class="sub_title mt-1">Manage Your Donations</div>
            <div class="btn c_g">Track Your Donations</div>
            <div class="btn c_g">Download Receipts</div>
          </div>
        </div>
      </div>

      <div class="card" id="h2">
        <button
          class="btn btn-link collapsed c_p"
          data-bs-toggle="collapse"
          data-bs-target="#c2"
          aria-expanded="false"
          aria-controls="c2"
        >
          Start as an NGO
        </button>
        <div
          id="c2"
          class="collapse"
          aria-labelledby="h2"
          data-bs-parent="#accordion"
        >
          <div class="card-body">
            <div id="ac2" class="accordion">
              <div class="sub_title mt-1">Manage Your NGO Profile</div>
              <div class="card" id="h11">
                <div
                  class="btn btn-link c_b"
                  data-bs-toggle="collapse"
                  data-bs-target="#c11"
                  aria-expanded="true"
                  aria-controls="c11"
                >
                  Edit NGO Profile
                </div>
                <div
                  id="c11"
                  class="collapse"
                  aria-labelledby="h11"
                  data-bs-parent="#ac2"
                >
                  <div class="card-body">
                    <div class="f_20">
                      Follow these steps to update your NGO information on
                      Shohay.
                    </div>
                    <div class="step" data-highlight="1. Select an NGO:">
                      Click on the <b>“Select an NGO”</b> dropdown in the top
                      left. Click the <b>“View Profile”</b> button for the NGO
                      you want to update.
                    </div>
                    <div
                      class="step"
                      data-highlight="2. Open the Update Profile Section:"
                    >
                      Click on the <b>“Update Profile”</b> button on the left.
                      The NGO Information tab will load.
                    </div>
                    <div
                      class="step"
                      data-highlight="3. Update NGO Information:"
                    >
                      In the NGO Information tab, sections can be updated
                      individually. Click the <b>“Edit”</b> button on the right
                      of each section to update. <b>Note:</b> Only one section
                      can be edited at a time.
                      <div class="mt-3 mb-2">
                        The following sections are available:
                      </div>
                      <div class="point" data-point="● General Information:">
                        NGO/NPO Name, Type (Profit/Non-Profit), Founding Year,
                        Team Size, Country, Logo.
                      </div>
                      <div class="point" data-point="● Contact Address:">
                        NGO Headquarters Address, Official Phone Number,
                        Official Email, Website.
                      </div>
                      <div class="point" data-point="● Mission & Vision:">
                        Define the mission and vision statement.
                      </div>
                      <div class="point" data-point="● Our Story:">
                        Provide a backstory of the NGO/NPO.Key Activities:
                        Outline main areas of focus.
                      </div>
                      <div class="point" data-point="● Profile Image:">
                        Upload a representative image.
                      </div>
                    </div>
                    <div
                      class="step"
                      data-highlight="4. Update Additional Information:"
                    >
                      If additional NGO/NPO information needs updating, go to
                      the
                      <b>“Additional Information”</b> tab.
                    </div>
                    <div
                      class="step"
                      data-highlight="5. Edit Additional Details:"
                    >
                      Each section in the Additional Information tab must be
                      edited separately by clicking the <b>“Edit”</b> button.
                      <div class="mt-3 mb-2">Available sections:</div>
                      <div class="point" data-point="● Contact:">
                        Name and phone number of the contact person.
                      </div>
                      <div
                        class="point"
                        data-point="● Follow Us & Stay Connected:"
                      >
                        Facebook, X (Twitter), YouTube, LinkedIn links.
                      </div>
                      <div class="point" data-point="● Awards and Recognition:">
                        Upload award captions, award pictures, and supporting
                        documents.
                      </div>
                      <div class="point" data-point="● Other Documents:">
                        Add any relevant NGO/NPO documents.
                      </div>
                    </div>
                    <div class="mt-2">
                      Once updates are completed, all changes will reflect in
                      the NGO profile.
                    </div>
                  </div>
                </div>
              </div>

              <div class="sub_title mt-1">Raise Funds</div>
              <div class="card" id="h22">
                <button
                  class="btn btn-link collapsed c_g"
                  data-bs-toggle="collapse"
                  data-bs-target="#c22"
                  aria-expanded="false"
                  aria-controls="c22"
                >
                  Set Up Donation Campaigns
                </button>
                <div
                  id="c22"
                  class="collapse"
                  aria-labelledby="h22"
                  data-bs-parent="#ac2"
                >
                  <div class="card-body">
                    <div class="f_20">
                      Follow these steps to create and manage a successful
                      donation campaign on Shohay.
                    </div>
                    <div
                      class="step"
                      data-highlight=" 1. Ensure You Have a Project:"
                    >
                      Donation campaigns must be created under a project. If you
                      haven't created a project yet, refer to the
                      <b> Project Creation Guide </b> and create one first.
                    </div>
                    <div
                      class="step"
                      data-highlight=" 2. Navigate to Donation Campaigns:"
                    >
                      From the <b>NGO Dashboard</b>, go to the
                      <b>left menu</b> and click <b>“Manage”</b>. Under Manage,
                      select <b>“Donation Campaigns”</b> to access the campaign
                      list.
                    </div>
                    <div
                      class="step"
                      data-highlight=" 3. Create a New Campaign:"
                    >
                      Click on the <b>“Create Campaign”</b> button to open the
                      campaign creation form.
                    </div>
                    <div
                      class="step"
                      data-highlight=" 4. Enter Campaign Details:"
                    >
                      <div class="mt-2 mb-2">Fill in the required fields:</div>
                      <div
                        class="point"
                        data-point="● Title of Campaign "
                      ></div>
                      <div
                        class="point"
                        data-point="● Subtitle of Campaign
                    "
                      ></div>
                      <div
                        class="point"
                        data-point="● Story of Campaign "
                      ></div>
                      <div
                        class="point"
                        data-point="● Story Summary of Campaign "
                      ></div>
                      <div
                        class="point"
                        data-point="● Cover Photo/Video
                    "
                      ></div>
                      <div
                        class="point"
                        data-point="● Contact Person’s Name "
                      ></div>
                      <div
                        class="point"
                        data-point="● Contact Person’s Job Title"
                      ></div>
                      <div
                        class="point"
                        data-point="● Contact Person’s Contact Info (Email/Phone)"
                      ></div>
                    </div>
                    <div
                      class="step"
                      data-highlight="5. Set Fundraising Target & Duration:"
                    >
                      <div class="mt-2 mb-2">
                        Choose from the following options:
                      </div>
                      <div class="point" data-point="● ">1 Month</div>
                      <div class="point" data-point="● ">2 Months</div>
                      <div class="point" data-point="● ">3 Months</div>
                      <div class="point" data-point="● ">4 Months</div>
                      <div class="point" data-point="● ">5 Months</div>
                      <div class="point" data-point="● ">
                        Rolling (until manually stopped)
                      </div>
                      <div class="point" data-point="● ">
                        Custom(set a start and end date)
                      </div>
                      <div class="mt-2">
                        Click <b>“Next”</b> after selection.
                      </div>
                    </div>
                    <div
                      class="step"
                      data-highlight="6. Configure Fundraising Options:"
                    >
                      <div class="point" data-point="● ">
                        Select <b>“With a Fundraising Team”</b> (default) or
                        <b> “Without a Fundraising Team” </b>.
                      </div>
                      <div class="point" data-point="● ">
                        If private fundraising members are needed, select
                        <b>“Private”</b>.
                      </div>
                      <div class="point" data-point="● ">
                        Enter invitation emails for fundraising team members.
                      </div>
                      <div class="point" data-point="● ">
                        Add a message for fundraising invitation emails.
                      </div>
                    </div>
                    <div
                      class="step"
                      data-highlight="7. Preview & Submit for Approval:"
                    >
                      <div class="point" data-point="● ">
                        Click <b>“Preview”</b> to see how the campaign will
                        appear.
                      </div>
                      <div class="point" data-point="● ">
                        If changes are needed, click <b>“Back to Edit”</b>.
                      </div>
                      <div class="point" data-point="● ">
                        Click
                        <b> “Create Campaign” </b> to finalize the campaign.
                      </div>
                    </div>
                    <div
                      class="step"
                      data-highlight="8. Request Campaign Approval:"
                    >
                      <div class="point" data-point="● ">
                        Go to the campaign list and click the
                        <b>three-dot menu</b> next to your campaign.
                      </div>
                      <div class="point" data-point="● ">
                        Select
                        <b>“Request for Approval”</b>.
                      </div>
                      <div class="point" data-point="● ">
                        If approved by Shohay, the campaign can be started.
                      </div>
                    </div>
                    <div
                      class="step"
                      data-highlight="9. Request Featured Campaign:"
                    >
                      <div class="point" data-point="● ">
                        To feature your campaign on the homepage: Go to the
                        campaign and click <b>“Request Featured”</b>.
                      </div>
                      <div class="point" data-point="● ">
                        Click <b>“Continue”</b> (only possible for approved
                        campaigns).
                      </div>
                    </div>
                    <div class="step" data-highlight="10. Start Your Campaign:">
                      <div class="point" data-point="● ">
                        Go to the campaign list and open the
                        <b>three-dot menu</b>.
                      </div>
                      <div class="point" data-point="● ">
                        Select <b>“Start Campaign”</b>.
                      </div>
                      <div class="point" data-point="● ">
                        Confirm by clicking <b>“Yes”</b>.
                      </div>
                    </div>
                    <div
                      class="step"
                      data-highlight="11. End a Campaign (Manually):"
                    >
                      <div class="point" data-point="● ">
                        Go to the campaign list and open the
                        <b>three-dot menu</b>.
                      </div>
                      <div class="point" data-point="● ">
                        Select <b>“End Campaign”</b>.
                      </div>
                      <div class="point" data-point="● ">
                        Confirm by clicking <b>“Yes”</b>.
                      </div>
                    </div>
                    <div class="mt-1">
                      Once approved and started, your campaign will be visible
                      to donors. You can track its progress in the NGO
                      Dashboard.
                    </div>
                  </div>
                </div>
              </div>

              <div class="card" id="h33">
                <button
                  class="btn btn-link collapsed c_g"
                  data-bs-toggle="collapse"
                  data-bs-target="#c33"
                  aria-expanded="false"
                  aria-controls="c33"
                >
                  Review Donations
                </button>
                <div
                  id="c33"
                  class="collapse"
                  aria-labelledby="h33"
                  data-bs-parent="#ac2"
                >
                  <div class="card-body">
                    <div class="f_20">
                      Follow these steps to review donation activities and track
                      fundraising progress in Shohay.
                    </div>
                    <div
                      class="step"
                      data-highlight="1. Navigate to the Donation Campaigns Section:"
                    >
                      From the<b> NGO Dashboard</b>, click on <b>“Manage”</b> in
                      the left menu and select <b>“Donation Campaigns”</b>.
                    </div>
                    <div
                      class="step"
                      data-highlight="2. Select a Campaign to Review:"
                    >
                      Find the campaign you want to review and click on it.
                    </div>
                    <div
                      class="step"
                      data-highlight="3. View Donation Performance:"
                    >
                      <div class="mt-2 mb-2">
                        The campaign details page includes:
                      </div>
                      <div class="point" data-point="● Total Supporters: ">
                        Number of donors who contributed.
                      </div>
                      <div class="point" data-point="● Total Raised: ">
                        The total amount collected.
                      </div>
                      <div class="point" data-point="● Time Remaining: ">
                        Days left before the campaign ends.
                      </div>
                      <div class="point" data-point="● Donation Analytics: ">
                        Graph showing donation trends.
                      </div>
                      <div class="point" data-point="● Recent Donations: ">
                        Latest contributions with donor messages.
                      </div>
                    </div>
                    <div
                      class="step"
                      data-highlight="4. Add Donor Messages to the Experience Wall:"
                    >
                      NGO admins can highlight impactful donation messages and
                      attach images.
                    </div>
                    <div
                      class="step"
                      data-highlight="5. Check Hall of Fame & Top Donors:"
                    >
                      <div class="mt-2 mb-2">
                        On the Shohay homepage, NGO admins can view:
                      </div>
                      <div class="point" data-point="● Top Donors: ">
                        Highest contributors to campaigns.
                      </div>
                      <div class="point" data-point="● Top Fundraisers: ">
                        Leading fundraising teams.
                      </div>
                    </div>
                    <div class="mt-2">
                      By reviewing donation performance, NGOs can track progress
                      and engage donors more effectively.
                    </div>
                  </div>
                </div>
              </div>

              <div class="card" id="h44">
                <button
                  class="btn btn-link collapsed c_g"
                  data-bs-toggle="collapse"
                  data-bs-target="#c44"
                  aria-expanded="false"
                  aria-controls="c44"
                >
                  Manage Social Media Sharing
                </button>
                <div
                  id="c44"
                  class="collapse"
                  aria-labelledby="h44"
                  data-bs-parent="#ac2"
                >
                  <div class="card-body">
                    <div f_20>
                      NGOs can promote their campaigns and engage with donors by
                      sharing updates on social media. Shohay allows users to:
                    </div>
                    <div class="point" data-point="● ">
                      Share campaigns on social media platforms.
                    </div>
                    <div class="point" data-point="● ">
                      Thank donors or groups of donors publicly.
                    </div>
                    <div class="point" data-point="● ">
                      Edit images and captions before posting.
                    </div>
                    <div class="point" data-point="● ">
                      Use an auto-generated template that can be customized or
                      copy the link to paste in a post.
                    </div>

                    <div class="step">
                      <div class="mb-2 fw-bold">How to Share a Campaign:</div>
                      <div class="point" data-point="● ">
                        Navigate to the <b>All Campaigns</b> page.
                      </div>
                      <div class="point" data-point="● ">
                        Select the campaign you want to share.
                      </div>
                      <div class="point" data-point="● ">
                        Click on the <b>“Share”</b> button.
                      </div>
                      <div class="point" data-point="● ">
                        Choose the social media platform (Facebook, X, LinkedIn,
                        Instagram, WhatsApp).
                      </div>
                      <div class="point" data-point="● ">
                        Edit the image or caption if needed.
                      </div>
                      <div class="point" data-point="● ">
                        Click <b>“Post”</b> to share the campaign.
                      </div>
                    </div>
                    <div class="step">
                      <div class="mb-2 fw-bold">
                        How to Share Donor Contributions:
                      </div>
                      <div class="point" data-point="● ">
                        Go to the <b>Donor Management</b> section.
                      </div>
                      <div class="point" data-point="● ">
                        Select an individual donor or group of donors.
                      </div>
                      <div class="point" data-point="● ">
                        Click <b>"Share Contribution"</b>
                      </div>
                      <div class="point" data-point="● ">
                        Customize the thank-you message and image.
                      </div>
                      <div class="point" data-point="● ">
                        Choose a platform and share.
                      </div>
                    </div>
                    <div class="step">
                      <div class="mb-2 fw-bold">
                        Editing Images and Captions:
                      </div>
                      <div class="point" data-point="● ">
                        Shohay generates a default template for campaign and
                        donor posts.
                      </div>
                      <div class="point" data-point="● ">
                        Before posting, NGOs can edit the text, images, and
                        hashtags.
                      </div>
                      <div class="point" data-point="● ">
                        Click <b>"Save Changes"</b> to apply edits before
                        posting.
                      </div>
                    </div>
                    <div class="mt-2">
                      By effectively using social media sharing, NGOs can
                      increase campaign visibility and donor engagement.
                    </div>
                  </div>
                </div>
              </div>

              <div class="card" id="h55">
                <button
                  class="btn btn-link collapsed c_g"
                  data-bs-toggle="collapse"
                  data-bs-target="#c55"
                  aria-expanded="false"
                  aria-controls="c55"
                >
                  Manage Donors
                </button>
                <div
                  id="c55"
                  class="collapse"
                  aria-labelledby="h55"
                  data-bs-parent="#ac2"
                >
                  <div class="card-body">
                    <div
                      class="step"
                      data-highlight="1. Navigate to the Donor CRM Section: "
                    >
                      From the <b>NGO Dashboard</b>, click on <b>"Manage"</b> in
                      the left menu and select <b>"Donor CRM."</b>
                    </div>
                    <div
                      class="step"
                      data-highlight="2. View Recent Donor Activity: "
                    >
                      <div class="mt-2 mb-2">The Donor Dashboard includes:</div>
                      <div class="point" data-point="● Donor Name"></div>
                      <div
                        class="point"
                        data-point="● Last Donation Date"
                      ></div>
                      <div
                        class="point"
                        data-point="● Campaign Supported"
                      ></div>
                      <div
                        class="point"
                        data-point="● Pledged or Donated Status"
                      ></div>
                    </div>
                    <div
                      class="step"
                      data-highlight="3. Access Individual Donor Profiles: "
                    >
                      <div class="mt-2 mb-2">
                        Click on a donor's name to view:
                      </div>
                      <div
                        class="point"
                        data-point="● Total Donation Amount"
                      ></div>
                      <div
                        class="point"
                        data-point="● First & Last Donation Date"
                      ></div>
                      <div
                        class="point"
                        data-point="● Donation Frequency"
                      ></div>
                      <div
                        class="point"
                        data-point="● List of Supported Campaigns"
                      ></div>
                      <div class="point" data-point="● Donation History"></div>
                      <div class="mt-2">
                        <b>Note: </b> No direct donor contact details will be
                        shown. NGOs must request access from Shohay for donor
                        communication. 21
                      </div>
                    </div>
                    <div
                      class="step"
                      data-highlight="4. View Donor Recognition & Top Donors: "
                    >
                      <div class="mt-2 mb-2">
                        The Donor Dashboard highlights:
                      </div>
                      <div class="point" data-point="● Top Donors: ">
                        Highest contributors to campaigns.
                      </div>
                      <div class="point" data-point="● Top Campaigns: ">
                        Most successful fundraising initiatives.
                      </div>
                    </div>
                    <div class="step" data-highlight="5. Export Donor Reports:">
                      Click on <b>"Export List"</b> to download donor records.
                    </div>
                    <div class="mt-2">
                      By managing donor insights effectively, NGOs can improve
                      engagement and fundraising performance.
                    </div>
                  </div>
                </div>
              </div>

              <div class="card" id="h66">
                <button
                  class="btn btn-link collapsed c_g"
                  data-bs-toggle="collapse"
                  data-bs-target="#c66"
                  aria-expanded="false"
                  aria-controls="c66"
                >
                  Apply For Institutional Donor Projects
                </button>
                <div
                  id="c66"
                  class="collapse"
                  aria-labelledby="h66"
                  data-bs-parent="#ac2"
                >
                  <div class="card-body">
                    <div class="f_20">
                      <b>Note:</b> All institutional donor project applications
                      are manually handled by Shohay. The following process
                      takes place after NGOs contact Shohay to express interest.
                    </div>
                    <div class="step">
                      <div class="mt-2 mb-2 f_20 fw-bold">
                        ● Apply for Institutional Donor Projects
                      </div>
                      <div class="mt-2 mb-2">
                        Shohay helps NGOs connect with institutional donors, but
                        all processes are currently handled manually by Shohay.
                      </div>
                      <div class="point" data-point="● Express Interest: ">
                        Inform Shohay that you are looking for institutional
                        funding.
                      </div>
                      <div
                        class="point"
                        data-point="● Provide Basic Information: "
                      >
                        Share details about your NGO, past projects, and funding
                        needs.
                      </div>
                      <div
                        class="point"
                        data-point="● Receive Personalized Guidance: "
                      >
                        Shohay will assess eligibility and match you with
                        potential opportunities.
                      </div>
                      <div
                        class="point"
                        data-point="● Get Assistance in Proposal Writing: "
                      >
                        Shohay will help draft and submit proposals for relevant
                        RFPs (Requests for Proposals).
                      </div>
                      <div
                        class="point"
                        data-point="● Partner with Large-Scale Donors: "
                      >
                        Shohay facilitates partnerships with institutional
                        funders on your behalf.
                      </div>
                      <div class="mt-2">
                        <a class="fw-bold c_0054a6" [routerLink]="'/contact-us'"
                          >[Contact us]</a
                        >
                        to start the application process. Shohay will guide you
                        through every step. 23
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="sub_title mt-1">Operate Your NGO</div>
              <div class="card" id="h77">
                <button
                  class="btn btn-link collapsed c_p"
                  data-bs-toggle="collapse"
                  data-bs-target="#c77"
                  aria-expanded="false"
                  aria-controls="c77"
                >
                  Set Up Projects
                </button>
                <div
                  id="c77"
                  class="collapse"
                  aria-labelledby="h77"
                  data-bs-parent="#ac2"
                >
                  <div class="card-body">
                    <div class="f_20">
                      Projects are required to start campaigns and publish forms
                      in Shohay. An NGO/NPO can have multiple projects, but
                      projects can only be created for approved NGOs/NPOs.
                    </div>
                    <div
                      class="step"
                      data-highlight="1. Navigate to the Projects Section: "
                    >
                      From the <b>NGO Dashboard</b>, click on <b>"Manage"</b> in
                      the left menu and select <b>"Projects."</b>
                    </div>
                    <div
                      class="step"
                      data-highlight="2. Create a New Project: "
                    >
                      Click on the <b>"Create Project"</b> button on the
                      projects landing page.
                    </div>
                    <div
                      class="step"
                      data-highlight="3. Create a Programme (if none exists): "
                    >
                      Click on the <b>"+"</b> button in the
                      <b>"Name of Programme"</b> field and provide:
                      <div class="point" data-point="● Programme Name"></div>
                      <div
                        class="point"
                        data-point="● Programme Description (Optional"
                      ></div>
                      <div
                        class="point"
                        data-point="● Operation Year (Optional)"
                      ></div>
                      <div class="mt-2">
                        Click <b>"Add"</b> to create the programme.
                      </div>
                    </div>
                    <div
                      class="step"
                      data-highlight="4. Enter Project Details: "
                    >
                      <div class="mt-2 mb-2"></div>

                      <div class="point" data-point="● Project Name"></div>
                      <div class="point" data-point="● Programme Name ">
                        Select from existing options)
                      </div>
                      <div
                        class="point"
                        data-point="● Start and End Date"
                      ></div>
                      <div class="point" data-point="● Area"></div>
                      <div
                        class="point"
                        data-point="● Project Objectives"
                      ></div>
                      <div class="mt-3 mb-2">
                        Additional optional fields include:
                      </div>
                      <div class="point" data-point="● ">Donor Name</div>
                      <div class="point" data-point="● ">
                        Target Beneficiaries
                      </div>
                      <div class="point" data-point="● ">
                        Impact of the Project
                      </div>
                    </div>
                    <div
                      class="step"
                      data-highlight="5. Finalize and Create the Project: "
                    >
                      Click the <b>"Create"</b> button. A success message will
                      confirm project creation, and the new project will appear
                      in the project list.
                    </div>
                    <div class="mt-3 mb-2 f_20 fw-bold">
                      Editing or Deleting a Project
                    </div>
                    <div class="step" data-highlight="6. Edit a Project:">
                      <div class="point" data-point="● ">
                        Go to the Projects List.
                      </div>
                      <div class="point" data-point="● ">
                        Click the 3-dot menu next to the project.
                      </div>
                      <div class="point" data-point="● ">
                        Select <b>"Edit"</b> to modify details.
                      </div>
                      <div class="point" data-point="● ">
                        Note: The Programme Name cannot be changed once a
                        project is created.
                      </div>
                      <div class="point" data-point="● ">
                        Click <b>"Update"</b> to save changes.
                      </div>
                    </div>
                    <div class="step" data-highlight="7. Delete a Project:">
                      <div class="point" data-point="● ">
                        Go to the Projects List.
                      </div>
                      <div class="point" data-point="● ">
                        Click the 3-dot menu next to the project.
                      </div>
                      <div class="point" data-point="● ">
                        Select <b>"Delete"</b> and confirm deletion.
                      </div>
                      <div class="point" data-point="● ">
                        <b>Warning:</b> Deleting a project will also remove
                        associated forms and campaigns.
                      </div>
                    </div>
                    <div class="mt-2">
                      With projects set up, NGOs can now create donation
                      campaigns and publish forms to support their initiatives.
                    </div>
                  </div>
                </div>
              </div>

              <div class="card" id="h88">
                <button
                  class="btn btn-link collapsed c_p"
                  data-bs-toggle="collapse"
                  data-bs-target="#c88"
                  aria-expanded="false"
                  aria-controls="c88"
                >
                  Manage Forms & Surveys
                </button>
                <div
                  id="c88"
                  class="collapse"
                  aria-labelledby="h88"
                  data-bs-parent="#ac2"
                >
                  <div class="card-body">
                    <div class="f_20">
                      Forms are used for surveying and data collection in
                      Shohayt. Forms are linked to projects and must be created
                      under an existing project.
                    </div>
                    <div
                      class="step"
                      data-highlight="1. Navigate to the Forms Section: "
                    >
                      From the <b>NGO Dashboard</b>, click on <b>"Manage"</b> in
                      the left menu and select <b>"Projects."</b> Choose a
                      project, then click <b>"Forms."</b>
                    </div>
                    <div class="step" data-highlight="2. Create a New Form: ">
                      Click on the <b>"New Form"</b> button.
                    </div>
                    <div class="step" data-highlight="3. Enter Form Details: ">
                      <div class="mt-2 mb-2"></div>
                      <div class="point" data-point="● Form Name"></div>
                      <div
                        class="point"
                        data-point="● Form Description (Optional)"
                      ></div>
                      <div class="mt-2">
                        Click <b>"Save and Close"</b> to save, or
                        <b>"Save and Next"</b> to continue adding questions.
                      </div>
                    </div>
                    <div
                      class="step"
                      data-highlight="4. Add Questions and Sections:"
                    >
                      <div class="mt-2 mb-2"></div>
                      <div class="point" data-point="● ">
                        Click <b>"Add New Section"</b> or
                        <b>"Add New Question."</b>
                      </div>
                      <div class="point" data-point="● ">
                        Enter Section Name and (Optional) Description.
                      </div>
                      <div class="point" data-point="● ">
                        Enter Question Text.
                      </div>
                      <div class="point" data-point="● ">
                        Select Question Type (e.g., Short Answer, Multiple
                        Choice, File Upload).
                      </div>
                      <div class="point" data-point="● ">
                        Set Validation Type (e.g., Numeric, Email, Decimal) if
                        applicable.
                      </div>
                      <div class="point" data-point="● ">
                        Toggle <b>"Required"</b> to make a question mandatory.
                      </div>
                    </div>
                    <div
                      class="step"
                      data-highlight="5. Save and Preview Form: "
                    >
                      Click <b>"Save"</b> before previewing. Click
                      <b>"Preview"</b> to check the form layout.
                    </div>
                    <div class="f_20 mt-2 mb-2 fw-bold">
                      Editing or Deleting Forms
                    </div>
                    <div class="step" data-highlight="6. Edit a Form:">
                      <div class="mt-2 mb-2"></div>
                      <div class="point" data-point="● ">
                        Go to the Forms List in the project.
                      </div>
                      <div class="point" data-point="● ">
                        Click the 3-dot menu next to the form.
                      </div>
                      <div class="point" data-point="● ">
                        Select <b>"Edit"</b> to modify questions or details.
                      </div>
                      <div class="point" data-point="● ">
                        Click <b>"Save"</b> to apply changes.
                      </div>
                    </div>
                    <div class="step" data-highlight="7. Delete a Form:">
                      <div class="mt-2 mb-2"></div>
                      <div class="point" data-point="● ">
                        Go to the Forms List.
                      </div>
                      <div class="point" data-point="● ">
                        Click the 3-dot menu next to the form.
                      </div>
                      <div class="point" data-point="● ">
                        Select <b>"Delete"</b> and confirm deletion.
                      </div>
                      <div class="point" data-point="● ">
                        <b>Warning:</b> Deleting a form removes all responses.
                      </div>
                    </div>
                    <div class="f_20 mt-2 mb-2 fw-bold">
                      Publishing and Viewing Responses
                    </div>
                    <div class="step" data-highlight="8. Publish a Form:">
                      <div class="mt-2 mb-2"></div>
                      <div class="point" data-point="● ">
                        Go to the Forms List.
                      </div>
                      <div class="point" data-point="● ">
                        Click the 3-dot menu next to the form.
                      </div>
                      <div class="point" data-point="● ">
                        Select <b>"Share"</b> to generate a shareable link.
                      </div>
                      <div class="point" data-point="● ">
                        Click <b>"Copy Link"</b> to distribute the form.
                      </div>
                    </div>
                    <div class="step" data-highlight="9. View Form Responses:">
                      <div class="mt-2 mb-2"></div>
                      <div class="point" data-point="● ">
                        Go to the Forms List.
                      </div>
                      <div class="point" data-point="● ">
                        Click the 3-dot menu next to the form.
                      </div>
                      <div class="point" data-point="● ">
                        Select <b>"Responses."</b> The response dashboard will
                        load.
                      </div>
                      <div class="point" data-point="● ">
                        View graphical summaries for multiple-choice questions.
                      </div>
                      <div class="point" data-point="● ">
                        Click the <b>"Individual"</b> tab to see individual
                        responses.
                      </div>
                    </div>
                    <div class="mt-2">
                      Forms and surveys help NGOs collect essential data for
                      project tracking and impact assessment.
                    </div>
                  </div>
                </div>
              </div>

              <div class="card" id="h99">
                <button
                  class="btn btn-link collapsed c_p"
                  data-bs-toggle="collapse"
                  data-bs-target="#c99"
                  aria-expanded="false"
                  aria-controls="c99"
                >
                  Review Reports
                </button>
                <div
                  id="c99"
                  class="collapse"
                  aria-labelledby="h99"
                  data-bs-parent="#ac2"
                >
                  <div class="card-body">
                    <div class="f_20">
                      Reports help NGOs analyze data and measure impact. Follow
                      these steps to review reports in Shohay.
                    </div>
                    <div
                      class="step"
                      data-highlight="1. Navigate to the Campaign Details and Donor CRM: "
                    >
                      NGO admins can find key reports in the
                      <b> Campaign Details </b> page and Donor CRM. There is no
                      dedicated <b>'Reports'</b> section in Shohay
                    </div>
                    <div
                      class="step"
                      data-highlight="2. Select a Report to Review: "
                    >
                      Choose from available reports related to donation
                      campaigns, surveys, and project impact.
                    </div>
                    <div class="step" data-highlight="3. View Report Summary: ">
                      <div class="mt-2 mb-2">
                        Reports provide an overview of key metrics such as:
                      </div>

                      <div
                        class="point"
                        data-point="● Total Donations Received"
                      ></div>
                      <div
                        class="point"
                        data-point="● Top Fundraising Campaigns"
                      ></div>
                      <div
                        class="point"
                        data-point="● Survey Participation Rates (Request from Shohay)"
                      ></div>
                      <div
                        class="point"
                        data-point="● Beneficiary Impact Metrics (Request from Shohay)"
                      ></div>
                    </div>
                    <div
                      class="step"
                      data-highlight="4. Filter and Customize Data: "
                    >
                      Use filters to sort reports by date, project, or donor
                      engagement.
                    </div>
                    <div class="step" data-highlight="5. Export Reports: ">
                      Click the <b>"Export"</b> button to download reports in
                      CSV or PDF format for offline analysis,
                    </div>
                    <div class="mt-2">
                      By reviewing reports, NGOs can track their fundraising
                      success and optimize their outreach strategies.
                    </div>
                  </div>
                </div>
              </div>

              <div class="card" id="h010">
                <button
                  class="btn btn-link collapsed c_p"
                  data-bs-toggle="collapse"
                  data-bs-target="#c010"
                  aria-expanded="false"
                  aria-controls="c010"
                >
                  Manage Specialized NGO Operations (Microfinance, WASH, etc.)
                </button>
                <div
                  id="c010"
                  class="collapse"
                  aria-labelledby="h010"
                  data-bs-parent="#ac2"
                >
                  <div class="card-body">
                    <div class="f_20">
                      <b>Note:</b> Shohay provides tools to manage specialized
                      NGO operations, but NGOs must contact Shohay to set up and
                      access these features, as they are not available directly
                      on the website.
                    </div>
                    <div class="step">
                      <div class="mt-2 mb-2 f_20 fw-bold">
                        ● Available Specialized NGO Operations
                      </div>
                      <div class="point" data-point="● Microfinance: ">
                        Offer small loans & track repayments.
                      </div>
                      <div
                        class="point"
                        data-point="● WASH (Water, Sanitation, and Hygiene): "
                      >
                        Manage clean water & sanitation projects.
                      </div>
                      <div class="point" data-point="● Health & Education: ">
                        Track outreach efforts and impact.
                      </div>
                      <div class="point" data-point="● Disaster Relief: ">
                        Set up emergency response campaigns.
                      </div>
                      <div
                        class="point"
                        data-point="● Partner with Large-Scale Donors: "
                      >
                        Shohay facilitates partnerships with institutional
                        funders on your behalf.
                      </div>
                      <div
                        class="point"
                        data-point="● Other Special Operations: "
                      >
                        NGOs can request customized support from Shohay.
                      </div>
                      <div class="mt-2">
                        <a class="fw-bold c_0054a6" [routerLink]="'/contact-us'"
                          >[Contact us]</a
                        >
                        to start the process. Shohay will assist in setting up
                        and managing these operations.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  }
</div>
